import { ChangeDetectorRef, Component, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { LogtoService } from '../../shared/services/logto.service';
import { LoginService } from '../../shared/services/login.service';

/** Landing page for Logto's redirect after sign-in (migration.html Logto-Umstieg, Plan Phase 4). */
@Component({
  templateUrl: './logto-callback.component.html',
  styleUrls: ['../login/login.component.scss', './logto-callback.component.scss'],
  standalone: false,
})
export class LogtoCallbackComponent {

  public message = '';
  public step = 0;

  constructor(private logtoService: LogtoService, private loginService: LoginService, private router: Router,
    private cdr: ChangeDetectorRef, private destroyRef: DestroyRef) { }

  async ngOnInit() {
    try {
      await this.logtoService.handleSignInCallback(window.location.href);
      if (this.destroyRef.destroyed) return;
      this.step = 1;
      this.cdr.detectChanges();
      const token = await this.logtoService.getOrganizationTokenForFirstOrg();
      await this.loginService.loginWithToken(token);
      if (this.destroyRef.destroyed) return;
      this.step = 2;
      this.cdr.detectChanges();
      await this.router.navigate(['']);
    } catch {
      if (this.destroyRef.destroyed) return;
      this.message = $localize`:@@callbackSignInFailed:Die Anmeldung konnte nicht abgeschlossen werden. Bitte melden Sie sich erneut an.`;
      this.cdr.detectChanges();
    }
  }
}
